import { UserResponse } from "@/types";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";



type InitialState = {
    data?: {
        customer: UserResponse['CustomerProfile'],
        companyCustomers: UserResponse['CompanyCustomers']
        invoiceAddress: UserResponse['InvoiceAddress']
    },
};

const initialState: InitialState = {
    data: undefined
};
const customerSlice = createSlice({
    name: 'customer',
    initialState,
    reducers: {
        setCustomer: (state, action: PayloadAction<{ invoiceAddress: UserResponse['InvoiceAddress'], customer: UserResponse['CustomerProfile'], companyCustomers: UserResponse['CompanyCustomers']}>) => {
            
            state.data = {
                companyCustomers: action.payload.companyCustomers,
                customer: action.payload.customer,
                invoiceAddress: action.payload.invoiceAddress
            }
        },
        updateCustomer: (state, action: PayloadAction<{ invoiceAddress: UserResponse['InvoiceAddress'], customer: UserResponse['CustomerProfile'], companyCustomers: UserResponse['CompanyCustomers']}>) => {
            if(!state.data) return;

            state.data.customer = action.payload.customer;
            state.data.invoiceAddress = action.payload.invoiceAddress;
        },
    }
});

export const  { setCustomer, updateCustomer } = customerSlice.actions;
export default customerSlice;